module.exports = __webpack_public_path__ + "img/FZLC_1.1a8f8814.jpg";